import { ReactNode } from 'react'

import { StyledList, StyledListItem, ZenkakuSpace } from '../TextStyle'
import { LinkText } from '@/components/elements/LinkText'

export const codeItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>第1条（人権の尊重）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            トライアルグループの基本方針
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                トライアルグループ（株式会社トライアルホールディングス及びそのグループ会社※をいう。）は、各国・各地域の法令等を踏まえ、人権に関する様々な国際規範を理解し、基本的人権を尊重します。また、児童労働、強制労働を認めません。
                <p>
                  ※株式会社トライアルホールディングスのグループ会社は
                  <LinkText path="/company/overview/" text="こちら" />
                  です。
                </p>
              </StyledListItem>
              <StyledListItem listType="number">
                トライアルグループにおいて、基本的人権を侵害する行為があった場合には、適切な措置を講じます。また、取引先においても、基本的人権を侵害する行為が認められる場合は、改善を求め適切な処置を行います。
                <br />
                人権尊重のため、関連するステークホルダーと対話を進めます。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            トライアルグループ役員・従業員の行動基準
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                個人の基本的人権、個性、プライバシーを尊重し、多様な価値観を受容します。
              </StyledListItem>
              <StyledListItem listType="number">
                人種、宗教、性別、国籍、心身障害、年齢、性的指向等に関する差別的言動、暴力行為、セクシャルハラスメント、パワーハラスメント等の人権を侵害する行為をしません。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy1',
  },
  {
    children: (
      <>
        <h3>第2条（お客様の尊重）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            トライアルグループの基本方針
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                法令を遵守し、契約事項を守るとともに、お客様に満足いただける商品、製品、システム、サービス（以下、「商品等」という）を提供します。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            トライアルグループ役員・従業員の行動基準
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                安全で信頼される商品等を提供します。
              </StyledListItem>
              <StyledListItem listType="number">
                商品等に関する情報提供を適切に行います。
              </StyledListItem>
              <StyledListItem listType="number">
                お客様の要望、相談に誠実、迅速かつ的確にお応えします。
              </StyledListItem>
              <StyledListItem listType="number">
                お客様の声を大切にし、ご満足いただける商品等の品ぞろえ、価格設定、開発、改善に努めます。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy2',
  },
  {
    children: (
      <>
        <h3>第3条（販売・生産・技術活動および品質活動）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            トライアルグループの基本方針
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                販売・生産・技術活動、品質活動に関係する法令および契約を遵守します。
              </StyledListItem>
              <StyledListItem listType="number">
                お客様にご満足いただける価格設定、不断の技術革新・生産性向上を図り、お客様のニーズに基づいた安全・安心で優れた商品等を最新、最良の技術により提供します。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            トライアルグループ役員・従業員の行動基準
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                お客様の立場に立って、品質保証の責任を果たし、商品等の安全を確保します。
              </StyledListItem>
              <StyledListItem listType="number">
                先進的な研究開発を進め、技術力の向上と技術基盤の整備に努めます。また、蓄積された技術と技能の継承に努めるとともに、技術環境の変化に的確に対応し、最新の技術を商品等に活用します。
              </StyledListItem>
              <StyledListItem listType="number">
                商品等に関する事故や安全に関する情報を入手した場合、直ちに事実確認を行い、社内規程等に基づき、お客様に必要な情報提供を行うとともに、商品・製品回収や注意喚起、警告表示等の適切な措置を講じます。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy3',
  },
  {
    children: (
      <>
        <h3>第4条（営業活動）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            トライアルグループの基本方針
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                法令を遵守するとともに、正しい企業倫理に基づき、公正な営業活動を行います。
              </StyledListItem>
              <StyledListItem listType="number">
                お客様のニーズに基づき、満足いただける優れた商品等を提供します。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            トライアルグループ役員・従業員の行動基準
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                誠意をもって全てのお客様に公正かつ公平に接し、適切な条件で取引を行います。
              </StyledListItem>
              <StyledListItem listType="number">
                法令を遵守し、健全な商慣行、社会通念に従った営業活動を行います。
              </StyledListItem>
              <StyledListItem listType="number">
                お客様のニーズを的確に把握し、最適な商品等を提供できるように努めます。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy4',
  },
  {
    children: (
      <>
        <h3>第5条（独占禁止法・官公庁取引規制等の遵守）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            トライアルグループの基本方針
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                独占禁止法その他の公正競争を維持するための法令等（以下、「独占禁止法等」という。）を遵守します。
              </StyledListItem>
              <StyledListItem listType="number">
                官公庁との取引にあたっては、法令および健全な商慣行を遵守します。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            トライアルグループ役員・従業員の行動基準
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                法令遵守に係る社内規程を遵守し、公正で自由な事業活動を推進します。
              </StyledListItem>
              <StyledListItem listType="number">
                お客様が官公庁の場合は、官公庁事業に係る社内規程等を遵守し、官公庁またはその職員（元職員を含み、以下同じとする。）に不正な見積額等、虚偽の情報を提供しません。
              </StyledListItem>
              <StyledListItem listType="number">
                会合の結成・参加、約束･取り決め、情報交換等の違法行為を疑われるような行為をしません。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy5',
  },
  {
    children: (
      <>
        <h3>第6条（贈賄の禁止）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            トライアルグループの基本方針
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                法令および健全な商慣行に反した不適正な支出を行いません。
              </StyledListItem>
              <StyledListItem listType="number">
                政治家または政治団体に対し、不適正な利益・便宜を供与しません。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            トライアルグループ役員・従業員の行動基準
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                官公庁の職員、みなし公務員、政治家等（元議員、秘書、元秘書、議員候補者等を含み、以下「公務員及び政治家等」という）、政治団体等に対し、法令および健全な商慣行に反し、報酬、接待、贈物その他いかなる形態を問わず、また、直接、間接を問わず、利益供与をしません（法令に違反せず、かつ社会的妥当性が認められる場合を除く）。また、通常の商慣行より有利な条件での販売および貸付等を行いません。
              </StyledListItem>
              <StyledListItem listType="number">
                官公庁向け営業につき、公務員及び政治家等本人または本人が関係する会社に対しても、口銭、コンサルタント料等の名目を問わず、金銭を支払わず、また、便宜を供与しません。
              </StyledListItem>
              <StyledListItem listType="number">
                外国公務員等に対し、国際的な商取引に関して営業上の不正の利益を得るために、金銭その他の利益を供与しません。
              </StyledListItem>
              <StyledListItem listType="number">
                代理店等の第三者に、前記（a）~（c）に定める禁止行為をさせません。
              </StyledListItem>
              <StyledListItem listType="number">
                代理店等を使用する場合、事前にその報酬等につき、合理的に取り決めます。報酬の支払につき法令上の規制があるときには、当該法令に従います。
              </StyledListItem>
              <StyledListItem listType="number">
                政治家または政治団体に対し、法令、社内規程に反した不適正な政治寄付等を行ないません。
              </StyledListItem>
              <StyledListItem listType="number">
                商取引上の接待、贈物、支出等を行う場合は、法令を遵守します。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy6',
  },
  {
    children: (
      <>
        <h3>第7条（反社会的勢力の排除）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            トライアルグループの基本方針
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                反社会的勢力（注1）との取引を含めた一切の関係を遮断します。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            トライアルグループ役員・従業員の行動基準
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                反社会的勢力による事業活動への関与を拒絶します。また、その活動を助長（注2）しません。
              </StyledListItem>
              <StyledListItem listType="number">
                不当要求（注3）を受けた場合には、毅然とした態度で要求を拒否します。
              </StyledListItem>
              <StyledListItem listType="number">
                マネー・ロンダリング（犯罪による収益の移転）を規制する法令等を遵守します。
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
        <StyledList marginLeft="5" paddingLeft="0.5">
          <StyledListItem listType="comment">
            反社会的勢力：暴力、威力と詐欺的手法を駆使して経済的利益を追求する集団または個人のことを指します。
          </StyledListItem>
          <StyledListItem listType="comment">
            その活動を助長する行為：機関誌・書籍の購読、物品の購入、広告賛助、役務提供等取引、金銭・物品の供与、その他の便宜供与等の行為をいいます。
          </StyledListItem>
          <StyledListItem listType="comment">
            不当要求：暴力団員による、事業活動に関し行われる暴力的要求行為等をいいます。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy7',
  },
  {
    children: (
      <>
        <p>
          制定日
          <ZenkakuSpace />
          2022年12月26日
        </p>
      </>
    ),
    id: 'policy8',
  },
]

export const codeLinks: {
  name: string
  anchor: string
}[][] = [
  [
    {
      name: '（人権の尊重）',
      anchor: 'policy1',
    },
    {
      name: '（お客様の尊重）',
      anchor: 'policy2',
    },
    {
      name: '（販売・生産・技術活動および品質活動）',
      anchor: 'policy3',
    },
    {
      name: '（営業活動）',
      anchor: 'policy4',
    },
  ],
  [
    {
      name: '（独占禁止法・官公庁取引規制等の遵守）',
      anchor: 'policy5',
    },
    {
      name: '（贈賄の禁止）',
      anchor: 'policy6',
    },
    {
      name: '（反社会的勢力の排除）',
      anchor: 'policy7',
    },
  ],
]
